// 轉盤上方 logo + 特效
import Image from 'next/image';

const CampaignRouletteLogo = () => {
    return (
        <div className="absolute top-[22px] left-[50%] translate-x-[-50%] z-[3]">
            <div className="relative">
                {/* logo */}
                <div className="img-box w-[81px] aspect-[81/26] after:content-none z-[2] usx:w-[75px] usx:scale-[.9]">
                    <Image width={81} height={26} src="/images/campaign/spin_logo.svg" alt="logo" />
                </div>
                {/* 圓圈 */}
                <div
                    className="absolute z-[1] overflow-hidden aspect-[1/1] bottom-[-50px] left-[50%] translate-x-[-50%] w-[168%] rounded-[50%] border-1 border-[#fff] border-opacity-[.3]
                backdrop-blur-[10px] bg-[#fff] bg-opacity-[.06] usx:w-[140%] usx:bottom-[-40px]"
                >
                    <div className="relative w-full h-full center-center">
                        {/* 六邊型特效 */}
                        <img
                            className="w-[78%] rounded-[50%] relative z-[1] border-1 border-[#fff] border-opacity-[.3] usx:w-[75%]"
                            src="/images/campaign/rectangle.gif"
                            alt="background"
                        />
                        {/* 星星特效 */}
                        <img
                            className="w-[176%] max-w-none absolute z-[0] mix-blend-lighten [@media(max-width:388px)]:w-[170%]"
                            src="/images/campaign/star.gif"
                            alt="background"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CampaignRouletteLogo;
